var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5043_33969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8C1.5 6.61929 2.61929 5.5 4 5.5H12C13.3807 5.5 14.5 6.61929 14.5 8V13C14.5 14.3807 13.3807 15.5 12 15.5H4C2.61929 15.5 1.5 14.3807 1.5 13V8Z",
    stroke: "#232A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21782 5.08723C2.98986 5.24308 2.93139 5.55421 3.08723 5.78218C3.24308 6.01014 3.55421 6.06861 3.78218 5.91277L3.21782 5.08723ZM3.78218 5.91277L10.2632 1.4822L9.69884 0.656662L3.21782 5.08723L3.78218 5.91277ZM11.0454 1.89496V5H12.0454V1.89496H11.0454ZM10.2632 1.4822C10.595 1.25533 11.0454 1.49297 11.0454 1.89496H12.0454C12.0454 0.688991 10.6944 -0.0239319 9.69884 0.656662L10.2632 1.4822Z",
    fill: "#232A2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 1,
    fill: "#232A2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5043_33969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.e65e2870f2156d8dd2ff3ddc940e9980.svg";
export { ForwardRef as ReactComponent };